import { CustomThemeToken } from '@/theme';
import { GlobalToken } from 'antd';
import { CanvasEngine, NodeModel } from '@projectstorm/react-diagrams';

import { Device } from '@/store/Station/constants';
import { DeviceType } from '@/constants/deviceTypeEnum';

import { Entity } from '../../nodes/nodeWidget/NodeWidget.types';

export interface SensorNodeWidgetProps {
  node: { entity: Entity; device: Device; getEntity; alerts; options: { type: string } } & NodeModel;
  width: number;
  height: number;
  data: {
    Icon?: React.ReactNode;
    metric?: string;
    unit?: string;
  }[];
  engine?: CanvasEngine;
}

export interface ContainerProps {
  theme: { token: GlobalToken };
  width: number;
  height: number;
  $isCombo?: boolean;
}

export const getWidgetBackgroundColor = (
  isSelected: boolean,
  inMaintenance: boolean,
  renderedOnMap: boolean,
  token: CustomThemeToken,
) => {
  if (inMaintenance && renderedOnMap) return token.Ecoplant_Compressor.colorBGMaintenance;

  return isSelected ? token.Ecoplant_Compressor.colorBGSelected : token.colorBgBase;
};

export const getWidgetBorderColor = (
  isSelected: boolean,
  inMaintenance: boolean,
  renderedOnMap: boolean,
  hasMissingData: boolean,
  token: CustomThemeToken,
): string => {
  if (inMaintenance && renderedOnMap) return token.colorWarningBorder;
  if (hasMissingData) return token?.colorPrimary;

  return isSelected ? token.colorPrimaryBorder : token.colorBorder;
};

export const getWidgetCircleColor = (isConnected: boolean, token: CustomThemeToken) =>
  isConnected ? token.colorPrimary : token.colorBorder;

export const getWidgetBorderStyle = (hasMissingData: boolean): string => {
  return hasMissingData ? 'dashed' : 'solid';
};

export const flowSensorMissingData = (entity: Entity): boolean => {
  const flowSensorTypes = [DeviceType.FlowSensor, DeviceType.FlowAndPressureSensor];
  
  if (!flowSensorTypes.includes(entity.deviceType)) {
    return false;
  }

  const pipeMaterial = entity.pipeMaterial;
  const pipeDiameter = entity.pipeDiameter;

  const isPipeMaterialMissing = !pipeMaterial;
  const isPipeDiameterMissing = pipeDiameter == null;

  return isPipeMaterialMissing || isPipeDiameterMissing;
};
